export default {
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    filterAttributes: {
      type: Array,
      default: () => [],
    },
    inputType: {
      type: String,
      default: 'plain_text',
    },
    dataType: {
      type: String,
      default: 'plain_text',
    },
    operators: {
      type: Array,
      default: () => [],
    },
    dropdownValues: {
      type: Array,
      default: () => [],
    },
    showQueryOperator: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default: () => null,
    },
    showUserInput: {
      type: Boolean,
      default: true,
    },
    groupedFilters: {
      type: Boolean,
      default: false,
    },
    filterGroups: {
      type: Array,
      default: () => [],
    },
    customAttributeType: {
      type: String,
      default: '',
    },
    showFilterOperator: {
      type: Boolean,
      default: true,
    },
    showFilterType: {
      type: Boolean,
      default: true,
    },
    queryOperators: {
      type: Array,
      default: () => [
        { value: 'and', label: 'FILTER.QUERY_DROPDOWN_LABELS.AND' },
        { value: 'or', label: 'FILTER.QUERY_DROPDOWN_LABELS.OR' },
      ],
    },
  },
  computed: {
    attributeKey: {
      get() {
        if (!this.value) return null;
        return this.value.attribute_key;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, attribute_key: value });
      },
    },
    filterOperator: {
      get() {
        if (!this.value) return null;
        return this.value.filter_operator;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, filter_operator: value });
      },
    },
    values: {
      get() {
        if (!this.value) return null;
        return this.value.values;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', {
          ...payload,
          values: value,
          inputType: this.inputType,
        });
      },
    },
    query_operator: {
      get() {
        if (!this.value) return null;
        return this.value.query_operator;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, query_operator: value });
      },
    },
    // eslint-disable-next-line camelcase
    custom_attribute_type: {
      get() {
        if (!this.customAttributeType) return '';
        return this.customAttributeType;
      },
      set() {
        const payload = this.value || {};
        this.$emit('input', {
          ...payload,
          custom_attribute_type: this.customAttributeType,
        });
      },
    },
    dateRange: {
      get() {
        if (!this.value || !this.value.values) return null;
        if (
          typeof this.value.values === 'object' &&
          this.value.values.from &&
          this.value.values.to
        ) {
          return [this.value.values.from, this.value.values.to];
        }
        return null;
      },
      set(value) {
        const payload = this.value || {};
        if (Array.isArray(value) && value.length === 2) {
          this.$emit('input', {
            ...payload,
            values: { from: value[0], to: value[1] },
            inputType: this.inputType,
          });
        }
      },
    },
    booleanFilterOperator() {
      return ['is_present', 'is_not_present'].includes(this.filterOperator);
    },
  },
  watch: {
    customAttributeType: {
      handler(value) {
        if (
          value === 'conversation_attribute' ||
          value === 'contact_attribute'
        ) {
          // eslint-disable-next-line vue/no-mutating-props
          this.value.custom_attribute_type = this.customAttributeType;
        } else {
          // eslint-disable-next-line vue/no-mutating-props
          this.value.custom_attribute_type = '';
        }
      },
      immediate: true,
    },
    filterOperator: {
      handler(value) {
        if (['is_present', 'is_not_present'].includes(value)) {
          this.values = '';
        }
      },
      immediate: true,
    },
  },
  methods: {
    removeFilter() {
      this.$emit('removeFilter');
    },
    resetFilter() {
      this.$emit('resetFilter');
    },
    getInputErrorClass(isDirty, hasError) {
      return isDirty && hasError
        ? 'bg-red-50 dark:bg-red-800/50 border-red-100 dark:border-red-700/50'
        : 'bg-white dark:bg-slate-800 border-slate-75 dark:border-slate-700/50';
    },
    confirmDateSelection() {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.handleConfirmDate();
      }
    },
    cancelDateSelection(emit) {
      if (this.$refs.datePicker && this.dateRange) {
        const dateRange = this.dateRange.map(date => {
          const [day, month, year] = date.split('-').map(Number);
          return new Date(year, month - 1, day);
        });
        emit(dateRange);
      }
      this.$refs.datePicker.closePopup();
    },
  },
};
